import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import brandLogo from "../KrivaBharatLogo.png";
import "../header.css";

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  const navLinks = [
    { label: "Mail", path: "/kmail" },
    { label: "FMS", path: "https://soft.krivabharat.com/", external: true },
  ];

  return (
    <header className="main-header">
      <div className="header-container">
        {/* Left Logo Section */}
        <div className="logo-section">
          <img src={brandLogo} alt="Kriva Bharat" className="logo-img" />
        </div>

        {/* Right Navigation */}
        <nav className={`nav-menu ${mobileMenuOpen ? "active" : ""}`}>
          {navLinks.map((link) => (
            <a
              key={link.path}
              href={link.path}
              onClick={() => !link.external && setMobileMenuOpen(false)}
              target={link.external ? "_blank" : undefined}
              rel={link.external ? "noopener noreferrer" : undefined}
              className={!link.external && isActive(link.path) ? "nav-link active" : "nav-link"}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Mobile Menu Toggle (3-dot icon) */}
        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
